module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"header":"Parcelas do recebimento"},"en-US":{"header":"Installments of the payment"}}')
  delete Component.options._Ctor
}
